import axios from 'axios';

import { httpService } from '../../../http-service/httpService';
import {
  axiosTimeoutConfig,
  DATA_FETCH_ERROR,
  FORCED_CANCELLATION,
  FORCED_CANCELLATION_MESSAGE,
  SET_DATA_FOR_ARS_MODAL,
  SET_ERROR_FOR_ARS_MODAL,
  SET_LOADING_FOR_ARS_MODAL,
  SET_OPEN_STATUS_AND_ARSTASKKEY_FOR_ARS_MODAL,
} from '../types';
import { URL_ARS_API } from '../urls';

let cancelTokenForAccessRequestHistory;

export const setIsARSModalOpen = (state, arsTaskPayload) => (dispatch) => {
  dispatch({
    type: SET_OPEN_STATUS_AND_ARSTASKKEY_FOR_ARS_MODAL,
    payload: { isOpen: state, arsTaskPayload },
  });

  if (!state) {
    setTimeout(() => {
      dispatch({
        type: SET_LOADING_FOR_ARS_MODAL,
        payload: true,
      });
    }, [500]);
  }
};

export const setIsARSModalLoading = (state) => (dispatch) => {
  dispatch({
    type: SET_LOADING_FOR_ARS_MODAL,
    payload: state,
  });
};

export const getAccessRequestHistoryData =
  (certkey, type, payload) => async (dispatch, getState) => {
    const { accessRequestHistory } = getState().certifications.details;

    const body = {
      certkey,
      ...payload,
    };

    if (!accessRequestHistory?.isLoading) {
      dispatch({
        type: SET_LOADING_FOR_ARS_MODAL,
        payload: true,
      });
    }

    dispatch({
      type: SET_ERROR_FOR_ARS_MODAL,
      payload: { isError: false, error: null },
    });

    try {
      if (typeof cancelTokenForAccessRequestHistory !== typeof undefined) {
        cancelTokenForAccessRequestHistory.cancel(FORCED_CANCELLATION_MESSAGE);
      }

      cancelTokenForAccessRequestHistory = axios.CancelToken.source();
      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken = cancelTokenForAccessRequestHistory.token;
      const { data } = await httpService.post(
        `${URL_ARS_API}/${type}`,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      dispatch({
        type: SET_LOADING_FOR_ARS_MODAL,
        payload: false,
      });

      dispatch({
        type: SET_DATA_FOR_ARS_MODAL,
        payload: response,
      });
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_DATA_FOR_ARS_MODAL,
          payload: null,
        });
      }

      dispatch({
        type: SET_ERROR_FOR_ARS_MODAL,
        payload: {
          isError: error?.code !== FORCED_CANCELLATION,
          error:
            error?.code === FORCED_CANCELLATION
              ? FORCED_CANCELLATION_MESSAGE
              : DATA_FETCH_ERROR,
        },
      });
    } finally {
      dispatch({
        type: SET_LOADING_FOR_ARS_MODAL,
        payload: false,
      });
    }
  };
